import { render, staticRenderFns } from "./psychological.vue?vue&type=template&id=1d356750&scoped=true&"
import script from "./psychological.vue?vue&type=script&lang=ts&"
export * from "./psychological.vue?vue&type=script&lang=ts&"
import style0 from "./psychological.vue?vue&type=style&index=0&id=1d356750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d356750",
  null
  
)

export default component.exports